import { Component } from '@angular/core';
import { UserService } from 'web-common/src/app/user/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    standalone: false
})
export class AppComponent {
  title = 'app works!';

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService.fetchUser().subscribe((user: any) => {
      const visitor = {
        id: user.id.replace('user:', ''),
        role: user.profile.role,
        area: user.profile.areaOfFocus,
        interfaceLanguage: user.preferences.language,
        trial: `${user.discountGroup.groupSettings.trial}`
      };
      const account = {
        id: user.discountGroup.id.replace('discount:', ''),
        accountName: user.discountGroup.institutionName
      };

      (window as any).pendo.initialize({visitor, account});
    }, error => {
      console.error('Cannot fetch user', error);
    });
  }
}
